export const errorCodeMap = (code: number) => {
  switch (code) {
    case 0:
      return 'It is OK.'
    case 3:
      return 'It is MCT issue.'
    case -1:
      return 'This is a error'
    case 97:
      return 'GSB invalid configurations'
    case 98:
      return 'GSB timeout'
    case 99:
      return 'GSB fail over'
    case 101:
      return 'Call API CAtConfManager::DistributeJoinConf|JoinConf OK (INTERMEDIA !!!)'
    case 102:
      return 'Call API CAtConfManager::JoinConf ERROR'
    case 103:
      return 'Call API CAtConfManager::DistributeJoinConf ERROR'
    case 104:
      return 'API IAtConfManagerSink::OnConfJoinConfirm was called and result == 0 (5016 will be converted to this value when non-EUREKA and CB)(FINAL NORMAL RESULT for PING and INTERMEDIA for CB !!!)'
    case 105:
      return 'API IAtConfManagerSink::OnConfJoinConfirm was called and result != 0 and result < 5000'
    case 106:
      return 'Wait IAtConfManagerSink::OnConfJoinConfirm called TIMEOUT'
    case 107:
      return 'Receive JMF_ERROR_CODE, please check dwErrorCode of OnTransportStatusIndication .'
    case 108:
      return 'API IAtConfManagerSink::OnConfJoinConfirm was called and result == 0 but there are not a correspond CB in our test list (FINAL NORMAL RESULT only for PING)'
    case 109:
      return 'API IAtConfManagerSink::OnConfJoinConfirm was called and result == 0 but the correspond CB has been tested (FINAL NORMAL RESULT only for PING)'
    case 110:
      return 'Error occured when wait IAtConfManagerSink::OnConfJoinConfirm was called'
    case 111:
      return 'Returned this after tested all sessions no matter what happend to single session (INTERMEDIA !!!)'
    case 112:
      return 'Call API CAtConfManager::CreateSession ERROR'
    case 113:
      return 'API IAtConfManagerSink::OnSessionCreateConfirm was called and result == 0'
    case 114:
      return 'API IAtConfManagerSink::OnSessionCreateConfirm was called and result != 0'
    case 115:
      return 'Wait IAtConfManagerSink::OnSessionCreateConfirm called TIMEOUT'
    case 116:
      return 'Error occured when wait IAtConfManagerSink::OnSessionCreateConfirm was called'
    case 117:
      return 'API IAtConfManagerSink::OnPenColorAssigned was called and result == 0'
    case 118:
      return 'Wait IAtConfManagerSink::OnPenColorAssigned called TIMEOUT'
    case 119:
      return 'Error occured when wait IAtConfManagerSink::OnPenColorAssigned was called'
    case 120:
      return 'Visit url for join conference and get "OKOKOK" (FINAL NORMAL RESULT)'
    case 121:
      return 'Visit url for join conference and get other content but "OKOKOK"'
    case 122:
      return 'Visit url for join conference TIMEOUT'
    case 123:
      return 'Error occured when visit url for join conference'
    case 126:
      return 'Could not create meeting in top zone, So skip join meeting'
    //'124': 'No storage configuration in MCT zone';
    case 124:
      return 'One storage configuration is blank in meeting zone'
    case 151:
      return 'Visit url get proper result (FINAL NORMAL RESULT)'
    case 152:
      return 'Visit url get improper result'
    case 153:
      return 'Visit url TIMEOUT'
    case 154:
      return 'Error occured when visit url'
    case 155:
      return 'Call API ATCreateTpProvider ERROR'
    case 156:
      return 'Call API IATTpProvider::Initialize OK (INTERMEDIA !!!)'
    case 157:
      return 'Call API IATTpProvider::Initialize ERROR (INTERMEDIA !!!)'
    case 158:
      return 'Call API IATTpProvider::CreateConnection ERROR '
    case 159:
      return 'Call API IATTpConnection::ConnectRequest OK (INTERMEDIA !!!)'
    case 160:
      return 'Call API IATTpConnection::ConnectRequest ERROR'
    case 161:
      return 'API IATTpConnectionSink::OnConnectConfirm was called and result == 0 (FINAL NORMAL RESULT !!!)'
    case 162:
      return 'API IATTpConnectionSink::OnConnectConfirm was called and result != 0'
    case 163:
      return 'Wait IATTpConnectionSink::OnConnectConfirm called TIMEOUT'
    case 164:
      return 'Error occured when wait IATTpConnectionSink::OnConnectConfirm was called'
    case 165:
      return 'Send request to web server ERROR'
    case 166:
      return 'API IATTpConnectionSink::OnDataIndication was called (FINAL NORMAL RESULT !!!)'
    case 167:
      return 'API IATTpConnectionSink::OnDataIndication was called'
    case 168:
      return 'Wait IATTpConnectionSink::OnDataIndication called TIMEOUT'
    case 169:
      return 'Error occured when wait IATTpConnectionSink::OnDataIndication was called'
    case 177:
      return 'Failed to get authentication ticket info from GAS server'
    case 201:
      return 'Call API DTTP_Initialize ERROR'
    case 202:
      return 'Call API DTTP_Listen ERROR'
    case 203:
      return 'Send DTMsg_ASK_CREATESUBSCRIBER pdu ERROR'
    case 204:
      return 'Send DTReq_Connect pdu OK (INTERMEDIA !!!)'
    case 205:
      return 'Send DTReq_Connect pdu ERROR'
    case 206:
      return 'Receive event DTEvt_ConnectConfirm and CDTPdu_Event_ConnectConfirm::m_dwResult != 0'
    case 207:
      return 'Send DTReq_CreateSubscriber pdu OK (INTERMEDIA !!!)'
    case 208:
      return 'Send DTReq_CreateSubscriber pdu ERROR'
    case 209:
      return 'Receive event DTEvt_CreateSubscriberReply and CDTPdu_Event_CreateSubscriberReply::m_dwResult != 0'
    case 210:
      return 'Send DTReq_OpenConference pdu OK (INTERMEDIA !!!)'
    case 211:
      return 'Send DTReq_OpenConference pdu ERROR'
    case 212:
      return 'Receive event DTEvt_RequestReply::DTReqReply_OpenConf and CDTPdu_Event_RequestReply::dwParam1 != 0'
    case 213:
      return 'Receive event DTEvt_ConfEvent::DTConfEvt_ConfOpenCfm and CDTPdu_Event_Conference::dwParam1 == (DT_E_DEV_ERROR | DT_E_DEV_BUSY)'
    case 214:
      return 'Receive event DTEvt_ConfEvent::DTConfEvt_ConfOpenCfm and CDTPdu_Event_Conference::dwParam1 != (DT_E_DEV_ERROR | DT_E_DEV_BUSY | 0)'
    case 215:
      return 'Receive event DTEvt_RequestReply::DTReqReply_OpenConf and CDTPdu_Event_RequestReply::dwParam1 == 0 (FINAL NORMAL RESULT !!!)'
    case 216:
      return 'Wait result TIMEOUT'
    case 217:
      return 'Error occured when wait result'
    //'220': 'Send DTReq_ConfMakeCall pdu ERROR';
    //'221': 'Wait DTEvt_ConfEvent::DTConfEvt_CallJoinCfm event and result is OK';
    //'222': 'Wait DTEvt_ConfEvent::DTConfEvt_CallJoinCfm event and result is FAILED';
    case 223:
      return 'Wait DTEvt_ConfEvent::DTConfEvt_CallJoinCfm event TIMEOUT'
    //'224': 'Error occured when wait DTEvt_ConfEvent::DTConfEvt_CallJoinCfm event';
    //'225': 'Send DTReq_MCTMakeCall pdu ERROR';
    //'226': 'Wait DTEvt_ConfEvent::DTConfEvt_CallJoinNtf event and result is OK';
    //'227': 'Wait DTEvt_ConfEvent::DTConfEvt_CallJoinNtf event and result is FAILED';
    case 228:
      return 'Wait DTEvt_ConfEvent::DTConfEvt_CallJoinNtf event TIMEOUT'
    //'229': 'Error occured when wait DTEvt_ConfEvent::DTConfEvt_CallJoinNtf event';
    //'230': 'Send DTMsg_ASK_CREATESUBSCRIBER pdu ERROR';
    //'231': 'Wait DTEvt_ConfEvent::DTMsg_RPY_CREATESUBSCRIBER event and result is OK';
    case 232:
      return 'Wait DTEvt_ConfEvent::DTMsg_RPY_CREATESUBSCRIBER event and result is FAILED'
    //'233': 'Wait DTEvt_ConfEvent::DTMsg_RPY_CREATESUBSCRIBER event TIMEOUT';
    //'234': 'Error occured when wait DTMsg_RPY_CREATESUBSCRIBER event';
    //'235': 'Send DTReq_Connect pdu ERROR';
    //'236': 'Wait DTEvt_ConfEvent::DTEvt_ConnectConfirm event and result is OK';
    case 237:
      return 'Wait DTEvt_ConfEvent::DTEvt_ConnectConfirm event and result is FAILED'
    case 238:
      return 'Wait DTEvt_ConfEvent::DTEvt_ConnectConfirm event TIMEOUT'
    case 239:
      return 'Error occured when wait DTEvt_ConnectConfirm event'
    case 240:
      return 'Send DTReq_CreateSubscriber pdu ERROR'
    case 241:
      return 'Wait DTEvt_ConfEvent::DTEvt_CreateSubscriberReply event and result is OK'
    case 242:
      return 'Wait DTEvt_ConfEvent::DTEvt_CreateSubscriberReply event and result is FAILED'
    case 243:
      return 'Wait DTEvt_ConfEvent::DTEvt_CreateSubscriberReply event TIMEOUT'
    case 244:
      return 'Error occured when wait DTEvt_CreateSubscriberReply event'
    case 245:
      return 'Call API DTTP_Initialize ERROR'
    case 246:
      return 'Call API DTTP_Listen ERROR'
    case 247:
      return 'Bad Call Out Phone number format'
    case 248:
      return 'Bad Call In Phone number format'
    case 249:
      return 'Bad Toll Phone (returned with DTConfEvt_CallJoinCfm event) number format'
    case 251:
      return 'Wait visit url returned TIMEOUT'
    case 252:
      return 'Error occured when wait visit url returned '
    case 253:
      return 'Call API RAUrl_Init ERROR'
    case 254:
      return 'Call API RAUrl_Get ERROR'
    case 255:
      return 'Visit url returned generic normal result (for user-defined) (FINAL NORMAL RESULT)'
    case 256:
      return 'Visit url returned generic unnormal result (for user-defined)'
    case 257:
      return 'Visit url returned "OKOKOK"  (FINAL NORMAL RESULT)'
    case 258:
      return 'Visit url returned "SUCCESS" (FINAL NORMAL RESULT)'
    case 259:
      return 'Visit url returned "FALSE"'
    case 260:
      return 'Visit url returned "<HTML>"'
    case 261:
      return 'Visit url reutrned "NOT FOUND"'
    case 262:
      return 'Visit url returned unknown content'
    case 263:
      return 'Visit url returned null content'
    case 264:
      return 'Visit url returned positive result'
    case 265:
      return 'Visit url returned negative result'
    case 266:
      return 'Find no url list in the cluster configuration'
    case 267:
      return 'At least one storage failed '
    case 268:
      return 'The post data is empty, please check the file whether exist in the folder Bin/Basic/Postdata'
    case 305:
      return 'Web server OK but test web logic FAIL'
    case 321:
      return 'Send mail OK (FINAL NORMAL RESULT !!!)'
    case 322:
      return 'configuration file wrong or mailto address is empty'
    case 323:
      return 'Send mail ERROR'
    case 324:
      return 'Mail service down or busy!'
    case 325:
      return 'Mail service do not receive the email!'
    case 351:
      return 'Call API CreateClientSessionManager ERROR'
    case 352:
      return 'Call API CreateIMSession ERROR'
    case 353:
      return 'Call API IIMSession::Initialize ERROR'
    case 354:
      return 'Call API IIMSession::Logon ERROR'
    case 355:
      return 'API IIMSessionSink::OnLogon was called and result == 0 (INTERMEDIA !!!)'
    case 356:
      return 'API IIMSessionSink::OnLogon was called and result != 0'
    case 357:
      return 'Wait IIMSessionSink::OnLogon called TIMEOUT'
    case 358:
      return 'Error occured when wait IIMSessionSink::OnLogon was called'
    case 359:
      return 'API IIMSessionSink::OnBuddyList was called (INTERMEDIA !!!)'
    case 360:
      return 'Wait IIMSessionSink::OnBuddyList called TIMEOUT'
    case 361:
      return 'Error occured when wait IIMSessionSink::OnBuddyList was called'
    case 362:
      return 'Call API CreateVoipSession ERROR'
    case 363:
      return 'Call API IIMSession::StartInvite ERROR'
    case 364:
      return 'API IIMSessionSink::OnStartInviteResponse was called (FINAL NORMAL RESULT !!!)'
    case 365:
      return 'Wait IIMSessionSink::OnStartInviteResponse called TIMEOUT'
    case 366:
      return 'Error occured when wait IIMSessionSink::OnStartInviteResponse was called'
    case 367:
      return 'Call API IClientSessionManager::SetPKCS7CA ERROR'
    case 368:
      return 'Call API IClientSessionManager::CreateAVSession ERROR'
    case 369:
      return 'Call API IAVSession::Connect ERROR'
    case 370:
      return 'API INetSessionSink::OnConnect was called and iReason == 0 (FINAL NORMAL RESULT !!!)'
    case 371:
      return 'API INetSessionSink::OnConnect was called and iReason != 0'
    case 372:
      return 'Wait INetSessionSink::OnConnect called TIMEOUT'
    case 373:
      return 'Error occured when wait INetSessionSink::OnConnect was called'
    case 374:
      return 'Miss uid and sid when test audio server (THIS WILL NOT HAPPENED NOW !!!)'
    case 375:
      return 'Miss param "-uid:" or "-pwd:"'
    case 401:
      return 'Call API CreateClientSessionManager ERROR'
    case 402:
      return 'Call API CreateIMSession ERROR'
    case 403:
      return 'Call API IClientSessionManager::CreateAVSession ERROR'
    case 404:
      return 'Call API IIMSession::Initialize ERROR'
    case 405:
      return 'Call API IIMSession::Logon ERROR'
    case 406:
      return 'Call API IIMSession::StartInvite ERROR'
    case 407:
      return 'Call API IAVSession::Connect ERROR'
    case 408:
      return 'Call API IAVSession::SendData ERROR'
    case 409:
      return 'API IIMSessionSink::OnLogon was called and result == 0'
    case 410:
      return 'API IIMSessionSink::OnLogon was called and result != 0'
    case 411:
      return 'Wait IIMSessionSink::OnLogon called TIMEOUT'
    case 412:
      return 'Error occured when wait IIMSessionSink::OnLogon was called'
    case 413:
      return 'API IIMSessionSink::OnBuddyList was called'
    case 414:
      return 'API IIMSessionSink::OnBuddyList was called'
    case 415:
      return 'Wait IIMSessionSink::OnBuddyList called TIMEOUT'
    case 416:
      return 'Error occurred when wait IIMSessionSink::OnBuddyList was called'
    case 417:
      return 'API IIMSessionSink:: OnStartInviteResponse was called'
    case 418:
      return 'API IIMSessionSink::OnStartInviteResponse was called'
    case 419:
      return 'Wait IIMSessionSink::OnStartInviteResponse called TIMEOUT'
    case 420:
      return 'Error occurred when wait IIMSessionSink:: OnStartInviteResponse was called'
    case 421:
      return 'API INetSessionSink:: OnConnect was called and iReason == 0'
    case 422:
      return 'API INetSessionSink:: OnConnect was called and iReason != 0'
    case 423:
      return 'Wait INetSessionSink:: OnConnect called TIMEOUT'
    case 424:
      return 'Error occurred when wait INetSessionSink:: OnConnect was called'
    case 425:
      return 'API INetSessionSink::OnReceive was called and start session confirm success'
    case 426:
      return 'APIINetSessionSink::OnReceive was called and start session confirm fail'
    case 427:
      return 'Wait INetSessionSink::WaitSessionResponse called TIMEOUT'
    case 428:
      return 'Error occurred when wait INetSessionSink::WaitSessionResponse was called'
    case 429:
      return 'Miss param "-uid:" and/or "-pwd:"'
    case 430:
      return 'VIP is not ready '
    case 431:
      return 'Can not get certificate'
    case 451:
      return 'Call API CreateStreamingSessionInstance ERROR'
    case 452:
      return 'Call API IStreamingSessionInterface::Initialize ERROR'
    case 453:
      return 'Call API IStreamingSessionInterface::JoinSession ERROR'
    case 454:
      return 'API IStreamingSessionSink::OnJoinSession was called and iiResultCode == 0'
    case 455:
      return 'API IStreamingSessionSink::OnSessionStatus was called and iStatus != 410'
    case 456:
      return 'Wait IStreamingSessionSink::OnJoinSession OR OnSessionStatus called TIMEOUT'
    case 457:
      return 'Error occured when wait IStreamingSessionSink::OnJoinSession OR IStreamingSessionSink was called'
    case 458:
      return 'API IStreamingSessionSink::OnSessionStatus was called and iStatus == 410 (backup mode)'
    case 461:
      return 'Call API MMCreateClientSession ERROR'
    case 462:
      return 'Call API IMmClientSession::SetOpt ERROR'
    case 463:
      return 'Call API IMmClientSession::JoinSession ERROR'
    case 464:
      return 'API IMmClientSessionSink::OnSessionJoin was called and cmResult == 0'
    case 465:
      return 'API IMmClientSessionSink::OnSessionJoin was called and cmResult != (0 AND 65004)'
    case 466:
      return 'Wait IMmClientSessionSink::OnSessionJoin called TIMEOUT'
    case 467:
      return 'Error occured when wait IMmClientSessionSink::OnSessionJoin was called'
    case 468:
      return 'API IMmClientSessionSink::OnSessionJoin was called and cmResult == 65004 (Conf not exist)'
    case 471:
      return 'Call API CAudioStreamingTicketFormat::Initialize ERROR'
    case 472:
      return 'Call API CAudioStreamingTicketFormat::Encrypt ERROR'
    case 473:
      return 'Generate Ticket SUCCESS'
    case 474:
      return 'Can not create conference before test MCC server'
    case 475:
      return 'The audio server not exist in our audio server list'
    case 476:
      return 'MCC server in backup mode'
    case 477:
      return 'Audio server have been tested with MCC server'
    case 478:
      return 'The server was skipped to test'
    case 479:
      return 'The conference not exist in MCC server'
    case 480:
      return 'Audio server have been tested with MCC server but failed'
    case 481:
      return 'Audio server returned by MCC is unexpected.'
    case 483:
      return 'Create conference OK, but join MMP failed.'
    case 484:
      return 'Wait DTEvt_ConfEvent:TConfEvt_CallJoinNtf event TIMEOUT.'
    case 485:
      return 'Error occured when wait DTEvt_ConfEvent:TConfEvt_CallJoinNtf event.'
    case 486:
      return 'TS or MCC tested failed,MCS server was skipped.'
    case 487:
      return 'Call API IMmClientSession::SendCommand with CMmPduNBRStart OK'
    case 488:
      return 'Call API IMmClientSession::SendCommand with CMmPduNBRStart ERROR'
    case 489:
      return 'API IMmClientSessionSink::OnReceiveCommand was called and status == NBR_STATUS_RECORDING (FINAL NORMAL RESULT !!!)'
    case 490:
      return 'API IMmClientSessionSink::OnReceiveCommand was called and status != NBR_STATUS_RECORDING'
    case 491:
      return 'Wait IMmClientSessionSink::OnReceiveCommand called TIMEOUT'
    case 492:
      return 'Error occured when wait IMmClientSessionSink::OnReceiveCommand was called'
    //'493': 'The MCC server was not config or be disabled, so the voip server was skipped to test';
    case 501:
      return 'Call API IIMSession::QueryUser ERROR'
    case 502:
      return 'API IIMSessionSink::OnQueryUserResponse was called and iResult == 0'
    case 503:
      return 'API IIMSessionSink::OnQueryUserResponse was called and iResult != 0'
    case 504:
      return 'Wait IIMSessionSink::OnQueryUserResponse called TIMEOUT'
    case 505:
      return 'Error occured when wait IIMSessionSink::OnQueryUserResponse was called'
    case 506:
      return 'Call API IIMSession::SendMessage ERROR'
    case 507:
      return 'API IIMSessionSink::OnMessage was called and returned sms server is OK'
    case 508:
      return 'API IIMSessionSink::OnMessage was called and returned sms server is FAIL'
    case 509:
      return 'Wait IIMSessionSink::OnMessage called TIMEOUT'
    case 510:
      return 'Error occured when wait IIMSessionSink::OnMessage was called'
    case 511:
      return 'Call API CreateVMailSession ERROR'
    case 512:
      return 'Call API IVMailSession::Initialize ERROR'
    case 513:
      return 'API IVMailSessionSink::OnVideoMailReady was called and iReason == RTSP_SUCCESS'
    case 514:
      return 'API IVMailSessionSink::OnVideoMailReady was called and iReason != RTSP_SUCCESS'
    case 515:
      return 'Wait IVMailSessionSink::OnVideoMailReady called TIMEOUT'
    case 516:
      return 'Error occured when wait IVMailSessionSink::OnVideoMailReady was called'
    case 517:
      return 'Call API IVMailSession::StartRecordMail ERROR'
    case 518:
      return 'API IVMailSessionSink::OnStartRecordMail was called and success == true'
    case 519:
      return 'API IVMailSessionSink::OnStartRecordMail was called and success != true'
    case 520:
      return 'Wait IVMailSessionSink::OnStartRecordMail called TIMEOUT'
    case 521:
      return 'Error occured when wait IVMailSessionSink::OnStartRecordMail was called'
    case 522:
      return 'Call API IVMailSession::StartPlayMail ERROR'
    case 523:
      return 'API IVMailSessionSink::OnStartPlayMail was called and success == true'
    case 524:
      return 'API IVMailSessionSink::OnStartPlayMail was called and success != true'
    case 525:
      return 'Wait IVMailSessionSink::OnStartPlayMail called TIMEOUT'
    case 526:
      return 'Error occured when wait IVMailSessionSink::OnStartPlayMail was called'
    case 527:
      return 'SMS server not been tested because no vip server is available'
    case 551:
      return 'Call API CreateNBRProvider ERROR'
    case 552:
      return 'Call GenerateTicket OK'
    case 553:
      return 'Call API CNBRConfTicketFormat::Initialize ERROR'
    case 554:
      return 'Call API CNBRConfTicketFormat::Encrypt ERROR'
    case 555:
      return 'Call API INBRProvider::JoinNBRProvider ERROR'
    case 556:
      return 'API INBRProviderSink::OnNBRProviderJoin was called and cmResult == 0'
    case 557:
      return 'API INBRProviderSink::OnNBRProviderJoin was called and cmResult != 0'
    case 558:
      return 'Wait INBRProviderSink::OnNBRProviderJoin called TIMEOUT'
    case 559:
      return 'Error occured when wait INBRProviderSink::OnNBRProviderJoin was called'
    case 560:
      return 'Call API INBRProvider::DownloadRequest ERROR'
    case 561:
      return 'API INBRProviderSink::OnNBRProviderStatus was called and ProviderStatus is not between 3000 and 5000'
    case 562:
      return 'API INBRProviderSink::OnNBRProviderStatus was called and ProviderStatus is between 3000 and 5000'
    case 563:
      return 'Wait INBRProviderSink::OnNBRProviderStatus called TIMEOUT'
    case 564:
      return 'Error occured when wait INBRProviderSink::OnNBRProviderStatus was called'
    case 565:
      return 'No msc server avaliable when test mss server'
    case 566:
      return 'Address returned by msc is not the server we are testing.'
    case 601:
      return 'Initialize WebACD library OK'
    case 602:
      return 'Call API create_webacd_mon_adapter ERROR'
    case 603:
      return 'Call API IAcdMonAdapter::MonitorAcdSvr ERROR'
    case 604:
      return 'Call API IAcdMonAdapter::MonitorBreSvr ERROR'
    case 605:
      return 'Call API IAcdMonAdapter::MonitorLoadBalance ERROR'
    case 606:
      return 'API IWebAcdMonSink::on_acd_check_result_indication was called and inResult == 0'
    case 607:
      return 'API IWebAcdMonSink::on_acd_check_result_indication was called and inResult != 0'
    case 608:
      return 'Wait IWebAcdMonSink::on_acd_check_result_indication called TIMEOUT'
    case 609:
      return 'Call API IWebAcdMonSink::on_acd_check_result_indication ERROR'
    case 610:
      return 'API IWebAcdMonSink::on_bre_check_result_indication was called and inResult == 0'
    case 611:
      return 'API IWebAcdMonSink::on_bre_check_result_indication was called and inResult != 0'
    case 612:
      return 'Wait IWebAcdMonSink::on_bre_check_result_indication called TIMEOUT'
    case 613:
      return 'Call API IWebAcdMonSink::on_bre_check_result_indication ERROR'
    case 614:
      return 'API IWebAcdMonSink::on_loadbalance_check_result_indication was called and inResult == 0'
    case 615:
      return 'API IWebAcdMonSink::on_loadbalance_check_result_indication was called and inResult != 0'
    case 616:
      return 'Wait IWebAcdMonSink::on_loadbalance_check_result_indication called TIMEOUT'
    case 617:
      return 'Call API IWebAcdMonSink::on_loadbalance_check_result_indication ERROR'
    case 651:
      return 'Call API CntCreateClientSession ERROR'
    case 652:
      return 'Call API ICntClientSession::Initialize ERROR'
    case 653:
      return 'Call API ICntClientSession::SetOption ERROR'
    case 654:
      return 'Call API ICntClientSession::JoinSession ERROR'
    case 655:
      return 'API ICntClientSessionSink::OnSessionJoin was called and cmResult == 0'
    case 656:
      return 'API ICntClientSessionSink::OnSessionJoin was called and cmResult != 0'
    case 657:
      return 'Wait	ICntClientSessionSink::OnSessionJoin called TIMEOUT'
    case 658:
      return 'Error occured when wait ICntClientSessionSink::OnSessionJoin was called'
    case 701:
      return 'Failed to delete destination file'
    case 703:
      return 'The destination file is not exist'
    case 704:
      return 'Failed when get file from remote server'
    case 707:
      return 'Timeout when get file from remote server'
    case 751:
      return 'External server error'
    case 782:
      return 'Failed to execute external command'
    case 783:
      return 'Execute external command timeout'
    case 784:
      return 'Receive dismatched output from command'
    case 785:
      return 'The parameter is not valid'
    case 801:
      return 'Call API AccCreateSession ERROR'
    case 802:
      return 'Call API Advise ERROR'
    case 803:
      return 'Call API IAccSession::get_ClientInfo ERROR'
    case 804:
      return 'Call API IAccSession::put_PrefsHook ERROR'
    case 805:
      return 'Call API IAccSession::put_Identity ERROR'
    case 806:
      return 'Call API IAccSession::SignOn ERROR'
    case 807:
      return 'Call API AccMessageLoop ERROR'
    case 808:
      return 'API CAccEventSink::OnStateChange was called and state == 500'
    case 809:
      return 'API CAccEventSink::OnStateChange was called and state != 500'
    case 810:
      return 'Wait CAccEventSink::OnStateChange called TIMEOUT'
    case 811:
      return 'Error occured when wait CAccEventSink::OnStateChange was called'
    case 812:
      return 'UI Configuration occues'
    case 821:
      return 'Call API CreateXmppConnect ERROR'
    case 822:
      return 'API CXmppSink::OnAuth was called and ulFlag != 0'
    case 823:
      return 'API CXmppSink::OnGetRoomList was called but filed'
    case 824:
      return 'API CXmppSink:: OnEnterRoom was called and ulFlag == 0'
    case 825:
      return 'API CXmppSink::OnLogin was called and ulFlag != 0'
    case 826:
      return 'No response from server, maybe server busy/down or server ip wrong'
    case 827:
      return 'Wait CXmppSink::OnLogin called ERROR'
    case 828:
      return 'Call API CChatXmppSink::C_GetRoomList ERROR'
    case 829:
      return 'API CXmppSink::OnEnterRoom was called and ulFlag >= 0'
    case 830:
      return 'API CXmppSink::OnEnterRoom was called and ulFlag < 0'
    case 831:
      return 'Wait	CXmppSink::OnEnterRoom called TIMEOUT'
    case 832:
      return 'Wait CXmppSink::OnEnterRoom called ERROR'
    case 833:
      return 'Call API CXmppSink::C_GetServerAddress ERROR'
    case 834:
      return 'API CXmppSink::OnGetServerAddress was called and ulFlag == 0'
    case 835:
      return 'API CXmppSink::OnGetServerAddress was called and ulFlag != 0'
    case 836:
      return 'Wait CXmppSink::OnGetServerAddress called TIMEOUT'
    case 837:
      return 'Wait CXmppSink::OnGetServerAddress called ERROR'
    case 838:
      return 'Ip address not match, maybe iRule has some problem'
    case 851:
      return 'Call API CP2pConn::P2pMonitor ERROR'
    case 852:
      return 'API CP2pConnSink::OnP2PMonitor was called and error_code == 0'
    case 853:
      return 'API CP2pConnSink::OnP2PMonitor was called and error_code != 0'
    case 854:
      return 'Wait CP2pConnSink::OnP2PMonitor called TIMEOUT'
    case 855:
      return 'Wait CP2pConnSink::OnP2PMonitor called ERROR'
    case 871:
      return 'Call API socket() ERROR'
    case 872:
      return 'Call API connect() ERROR'
    case 873:
      return 'Call API send() ERROR'
    case 874:
      return 'Call API recv() ERROR'
    case 875:
      return 'Call API select() ERROR'
    case 876:
      return 'Wait server response and result is OK'
    case 877:
      return 'Wait server response but result is FAILED'
    case 878:
      return 'Wait server response TIMEOUT'
    case 879:
      return 'Wait server response but socket is closed'
    //modified by Silver Wu, 20071106
    case 892:
      return 'Create conference failed in TS, please check TS logs for detail'
    case 893:
      return 'Invalid phone number format'
    case 894:
      return 'Call telephony number no response, One of CallJoinCfm, ActiveSpeakerNfy PDU missed'
    case 895:
      return 'TS response the call but invalid dwParam1 value'
    case 896:
      return 'Get ActiveSpeakerNfy PDU but invalid dwParam2 value'
    case 898:
      return 'CallJoinCfm missed, the user not join conf but get his voice, please check TS logs for detail'
    //'897': 'Wait DTEvt_ConfEvent:: DTConfEvt_CallPrivilegeChanged event and result is OK';
    case 1101:
      return 'Program teminate by ra gsb service'
    case 1102:
      return 'Get ra server configuration success by visit url'
    case 1103:
      return 'Get ra server configuration failed by visit url'
    case 1104:
      return 'Error occurs when get ra server option by visit url'
    case 1105:
      return 'Get ra server configuration timeout by visit url'
    case 1106:
      return 'Get ra ping server success by visit url'
    case 1107:
      return 'Get ra ping server failed by visit url'
    case 1108:
      return 'Error occurs when get ra server by visit url'
    case 1109:
      return 'Get ra server timeout by visit url'
    case 1110:
      return 'Get ra server success by visit url'
    case 1111:
      return 'Get ra server failed by visit url'
    case 1112:
      return 'Error occurs when get ra server by visit url'
    case 1113:
      return 'Get ra server timeout by visit url'
    case 1114:
      return 'Call API ATCreateTpProvider ERROR'
    case 1115:
      return 'Call API IATTpProvider::Initialize ERROR'
    case 1116:
      return 'Call API IATTpProvider::CreateConnection ERROR'
    case 1117:
      return 'Call API IATTpConnection::ConnectRequest ERROR'
    case 1118:
      return 'Call API IATTpConnection::ConnectRequest OK (INTERMEDIA !!!)'
    case 1119:
      return 'API IATTpConnectionSink::OnConnectConfirm was called and result == 0'
    case 1120:
      return 'API IATTpConnectionSink::OnConnectConfirm was called and result != 0'
    case 1121:
      return 'Wait IATTpConnectionSink::OnConnectConfirm called TIMEOUT'
    case 1122:
      return 'Error occured when wait IATTpConnectionSink::OnConnectConfirm was called'
    case 1123:
      return 'API IATTpConnectionSink::OnDisconnectIndication was called'
    case 1124:
      return 'API IATTpConnectionSink::OnDataIndication was called and Action = RAPDU_Action_ASK_ReLogin'
    case 1125:
      return 'Error occurs when wait server event'
    case 1126:
      return 'GSB fail over happened'
    case 1127:
      return 'Failed to get authentication ticket info from GAS server'
    //Add  in MCT9.1.  Monitor Primary/Backup MZM,WWP SAS(Eureka3.9) and PCnow(Eureka3.8)
    case 136:
      return 'Primary and backup mzm both alive'
    case 902:
      return 'Can not create socket to connect server'
    case 903:
      return 'Can not connect to primary server, please check WWP Primary Server'
    case 904:
      return 'Primary and backup WWP both alive'
    case 908:
      return 'Can not create socket to connect server'
    case 909:
      return 'Can not connect to Stream application server'
    case 1151:
      return 'Can not get agent information from site, please check the url or the site'
    case 1152:
      return 'Got unknown format from site'
    case 1153:
      return 'Can not create conference, DistributeJoinConf function failed'
    case 1154:
      return 'Can not create conference, CreateConference confirm indicated failed'
    case 1155:
      return 'Conference had been terminated by server'
    case 1156:
      return 'GSB fail over happened.'
    case 1157:
      return 'Current test still in progress.'
    case 1158:
      return 'Wait Conference confirm timeout!'
    //Add  in MCT9.2. Quick Share Server / NBR monitoring on TS / MMP Enhancements / PCN Account / level 3 number
    case 171:
      return 'Error occurred when forward action from one quick share server to another'
    case 172:
      return 'Everything is OK, it will record 0 to database'
    case 173:
      return 'Failed occurred when wait host quick share server receive forward action from attendee quick share server'
    case 174:
      return 'Timeout when wait host quick share server receive forward action from attendee quick share server'
    case 175:
      return 'Error occurred when wait host quick share server receive forward action from attendee quick share server'
    case 176:
      return 'Quick share server is skipped because host quick share server is failed'
    case 220:
      return 'Can not send DTApp_SSREvent_Connect pdu to server'
    case 221:
      return 'Receive DTApp_SSREvent_OnConnect pdu from server and indicate error occurred'
    case 222:
      return 'Can not send DTApp_SSREvent_Start pdu to server'
    case 224:
      return 'Receive DTApp_SSREvent_OnStart pdu from server and indicate error occurred'
    case 225:
      return 'Timeout when wait DTApp_SSREvent_OnStart pdu'
    case 226:
      return 'Error occurred when wait DTApp_SSREvent_OnStart pdu'
    case 227:
      return 'Can not send DTApp_SSREvent_Stop pdu to server'
    case 229:
      // eslint-disable-next-line quotes
      return "Received DTApp_SSREvent_NotifyFileInfo pdu and indicate file size doesn't match configuration"
    case 230:
      return 'Timeout when wait DTApp_SSREvent_NotifyFileInfo pdu'
    case 231:
      return 'Error occurred when wait DTApp_SSREvent_NotifyFileInfo pdu'
    case 493:
      return 'The server is skipped this time'
    case 494:
      return 'Voip is not test because no mcc server'
    case 495:
      return 'Audio server Can not be test because ts or mcc fail'
    case 233:
      return 'Can not connect to server(ipaddress:7676),'
    case 234:
      return 'Server confirm pdu indicate failed (result != 0)'
    case 235:
      return 'Timeout when wait PCN confirm pdu'
    case 236:
      return 'Error occurred when wait PCN confirm pdu'
    case 1201:
      return 'OnConnect is received, failed to call out to bridge'
    case 1202:
      return 'OnDisconnect is received, abnormal disconnect from TS'
    case 1203:
      return 'OnStop is received, abnormal stop from TS'
    case 1204:
      return 'Failed to create meeting 1(M1)'
    case 1205:
      return 'The server is skipped in the round test'
    case 1206:
      return 'Previous test is still in running'
    case 1207:
      return 'Failed to call out phone number'
    case 1208:
      return 'Incorrect host access code'
    //Add  in MCT9.4, MCT Box / Join meeting test through mobile gateway / Generic port monitoring
    case 921:
      return 'No MCT Station Server information'
    case 922:
      return 'The Wait Queue of MCT Station is nonzero'
    case 923:
      return 'The Command line is not valid'
    case 924:
      return 'Can not create socket to test mct box'
    case 925:
      return 'Can not connect to mct box'
    case 931:
      return 'System error occurred when test generic port server'
    case 932:
      return 'Configuration is not format for this server'
    case 933:
      return 'The request file in not exist in postdata folder'
    case 934:
      return 'Can not connect to port server'
    case 935:
      return 'Timeout when wait port server response'
    case 936:
      return 'Got an unexpected result, it is not match positive and negative condition'
    case 937:
      return 'Got a result that match the negative condition'
    case 938:
      return 'We are closed by port server'
    case 926:
      return 'The dispatch ipaddress config error'
    //Add  in MCT9.5, Mobile gateway & tomcat gateway / MP(Alta)
    case 127:
      return 'Missing mzm configration entry'
    case 128:
      return 'External meeting is skipped because top mzm can not create meeting'
    case 138:
      return 'Mobile gateway is skipped because mzm can not create meeting'
    case 139:
      return 'System socket error when test mobile gateway'
    case 140:
      return 'Can not connect mobile gateway server'
    case 141:
      return 'Return code of RegisterNodeConfirm is not zero or miss token element'
    case 142:
      return 'Timeout to wait RegisterNodeConfirm response'
    case 143:
      return 'Return code of JoinConfConfirm is not zero'
    case 144:
      return 'Timeout to wait JoinConfConfirm response'
    case 145:
      return 'Mobile web is skipped because mzm can not create meeting'
    case 147:
      return 'Timeout to wait Url Station response'
    case 148:
      return 'The Url Station Response is not OKOKOK'
    case 149:
      return 'System error when visit Url Station'
    //Add  in MCT9.6, TP Gateway
    case 941:
      return 'Timeout when visit url to test video session through TP gateway'
    case 942:
      return 'The result that url returned is not OKOKOK'
    case 943:
      return 'Error occured when visit url to test video session by through TP gateway'
    case 944:
      return 'LocalDCID parameter is null'
    //Add  in MCT9.8 Memcache Server, 951-955 for memcache server; 961-985 for GPS & account presence server; 991-996 for message server
    case 951:
      return 'Connect to MemCache Server failed.'
    case 952:
      return 'Add data to MemCache Server failed.'
    case 953:
      return 'Get data from MemCache Server failed'
    case 954:
      return 'Delete data from MemCache Server failed'
    case 955:
      return 'Time out when getting response from MemCache Server after Add, Get or Delete'
    case 961:
      return 'CAS server auth failed'
    case 962:
      return 'CAS server auth timeout'
    case 963:
      return 'CAS server returned unknown content'
    case 964:
      return 'Login WAPI server failed'
    case 965:
      return 'WAPI server auth timeout'
    case 966:
      return 'WAPI server returned unknown content'
    case 967:
      return 'Login Jabber api failed'
    case 968:
      return 'Wait login jabber result, get OK'
    case 969:
      return 'Wait login jabber result, get failed'
    case 970:
      return 'Wait login jabber result timeout'
    case 971:
      return 'Error to wait login jabber result'
    case 972:
      return 'Search ldap group api failed'
    case 973:
      return 'Wait search ldap group result, get OK'
    case 974:
      return 'Wait search ldap group result, get failed'
    case 975:
      return 'Wait search ldap group result timeout'
    case 976:
      return 'Error to wait search ldap group result'
    case 977:
      return 'Subscribe ldap group api failed'
    case 978:
      return 'Wait subscribe ldap group result, get OK'
    case 979:
      return 'Wait subscribe ldap group result, get failed'
    case 980:
      return 'Wait subscribe ldap group result timeout'
    case 981:
      return 'Error to wait subscribe ldap group result'
    case 982:
      return 'Wait second user presence, get OK'
    case 983:
      return 'Wait second user presence, get failed'
    case 984:
      return 'Wait second user presence timeout'
    case 985:
      return 'Error to wait second user presence'
    case 986:
      return 'The second user CAS login failed'
    case 987:
      return 'The second user WAPI login failed'
    case 988:
      return 'The second user JABBER login failed'
    case 991:
      return 'Create Message Client api failed'
    case 992:
      return 'Message Client initialize failed'
    case 993:
      return 'Message Client send message failed'
    case 994:
      return 'Checked message sent failed'
    case 995:
      return 'Wait check message result timeout'
    case 996:
      return 'Mail service not get message from message server'
    //Add  in MCT9.10 IMDS server 1301-1320
    case 1301:
      return 'Can not visit cas server to get token'
    case 1302:
      return 'Timeout when visit cas server'
    case 1303:
      return 'Unknown result returned by CAS server'
    case 1304:
      return 'Can not visit WAPI server to get token'
    case 1305:
      return 'Timeout when visit WAPI server'
    case 1306:
      return 'Unknown result returned by WAPI server'
    case 1307:
      return 'Call Xmpp login failed'
    case 1309:
      return 'Xmpp login callback return failed'
    case 1310:
      return 'Timeout when wait xmpp login callback'
    case 1311:
      return 'System error when wait xmpp login callback'
    case 1312:
      return 'Call Xmpp create group chat failed'
    case 1314:
      return 'Xmpp create group chat callback return failed'
    case 1315:
      return 'Timeout when wait xmpp create group chat callback'
    case 1316:
      return 'System error when wait xmpp create group chat callback'
    case 1317:
      return 'Call Xmpp send message failed'
    case 1318:
      return 'System error when check mail'
    case 1319:
      return 'Check mail get failed, means not receive message'
    case 1320:
      return 'Chack mail and send message all failed'

    case 3001:
      return 'This is a alert level error'
    case 3002:
      return 'This is a common level error'
    case 3003:
      return 'This is a critical level error'
    case 3004:
      return 'Wait the plugin server timeout'

    case 5000:
      return 'This is a mark and it will not be write into database'
    case 6000:
      return 'This is a 3rd party external server alarm'
    default:
      return 'This is a common level error'
  }
}
